import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NatalChartHeader({
  chart,
  showBirthData,
  onToggle,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation('natal');

  return (
    <>
      <button
        type="button"
        className="natal-floating-top-back"
        aria-label={t('back')}
        title={t('back')}
        onClick={() => navigate(-1)}
      >
        <span
          className="natal-floating-top-back-glow"
          aria-hidden="true"
        />
        <span
          className="natal-floating-top-back-icon"
          aria-hidden="true"
        >
          ‹
        </span>
      </button>

      <header className="natal-premium-header">
        <span
          className="natal-header-spacer"
          aria-hidden="true"
        />

        <div className="natal-header-copy">
          <span className="natal-header-eyebrow">ZODIACUS · OBSERVATORIO NATAL</span>
          <h1>✨ {t('title')}</h1>
          <p>{t('subtitle')}</p>
        </div>

        <span
          className="natal-header-spacer"
          aria-hidden="true"
        />
      </header>

      {chart ? (
        <div className="natal-success-pill">
          ✅ {t('calculated')}
        </div>
      ) : null}

      {chart ? (
        <button
          type="button"
          className="natal-birth-toggle"
          onClick={onToggle}
          aria-expanded={showBirthData}
        >
          <span className="natal-birth-toggle-icon" aria-hidden="true">
            {showBirthData ? '✕' : '✏️'}
          </span>

          <span className="natal-birth-toggle-copy">
            <span className="natal-birth-toggle-eyebrow">DATOS NATALES</span>
            <strong>
              {showBirthData ? 'Ocultar datos natales' : 'Editar datos natales'}
            </strong>
            <small>
              {showBirthData
                ? 'Los cambios se aplicarán cuando vuelvas a calcular tu carta.'
                : 'Revisa o modifica tu información de nacimiento.'}
            </small>
          </span>

          <span
            className={`natal-birth-toggle-chevron${
              showBirthData ? ' is-open' : ''
            }`}
            aria-hidden="true"
          >
            ⌄
          </span>
        </button>
      ) : (
        <div
          className="natal-birth-toggle natal-birth-onboarding"
          style={{
            cursor: 'default',
            gridTemplateColumns: '36px minmax(0, 1fr) auto',
          }}
        >
          <span className="natal-birth-toggle-icon" aria-hidden="true">
            ✏️
          </span>

          <span className="natal-birth-toggle-copy">
            <span className="natal-birth-toggle-eyebrow">PASO 1</span>
            <strong>Completa tus datos natales</strong>
            <small>Fecha, hora y lugar de nacimiento para calcular tu carta.</small>
          </span>

          <span
            className="natal-birth-toggle-status"
            aria-hidden="true"
            style={{
              justifySelf: 'end',
              padding: '5px 8px',
              border: '1px solid rgba(241, 200, 90, 0.34)',
              borderRadius: 999,
              color: '#fff4c7',
              fontSize: 10,
              fontWeight: 800,
              whiteSpace: 'nowrap',
            }}
          >
            Empezar
          </span>
        </div>
      )}
    </>
  );
}
